import app from '@/app';
import templateUrl from './project-search.html';

/* @ngInject */
function Controller($controller, $state, $uibModal, ProjectEntity, Principal, AlertService) {
	var $ctrl = this;
	var resource = ProjectEntity;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		transition(params);
		$ctrl.name = params.name;
		ProjectEntity.query(
			{
				name: $ctrl.name,
				sort: $ctrl.sort,
				page: $ctrl.page,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	var removeProject = entity => {
		resource.remove({ id: entity.id }, () => {
			AlertService.success('entity.delete.message', {
				type: 'project',
				name: entity ? entity.name : ''
			});
			$state.reload();
		});
	};

	$ctrl.remove = id => {
		var entity = $ctrl.entities.find(e => e.id === id);
		if (!entity || entity.id === 0) {
			removeProject(entity);
			return;
		}

		resource.dependencies({ id: id }).$promise.then(dependencies => {
			$uibModal
				.open({
					component: 'projectDeleteConfirmDialog',
					resolve: {
						bindings: () => ({ project: entity, dependencies: dependencies })
					}
				})
				.result.then(() => removeProject(entity));
		});
	};

	$ctrl.onQueryChange = () => {
		$state.go(
			$state.current,
			{
				page: 0,
				name: $ctrl.name
			},
			{
				reload: true
			}
		);
	};
}

const component = {
	templateUrl,
	controller: Controller,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allMeasurements: '<',
		allMetrics: '<'
	}
};

app.component('projectSearch', component);
